module.exports = __webpack_public_path__ + "img/logo-wize.e003955c.png";